module.exports = __webpack_public_path__ + "img/globe.775334b6.svg";